const styleSheet = () => ({
  row: {
    padding: (props: any) => props.padding,
    position: 'relative',
    boxShadow: '0 2px 8px 0 rgba(0,0,0,0)',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: (props: any) => props.justifyContent || 'flex-start',
    alignItems: (props: any) => props.alignItems || 'center',
    height: '62px',

    '& > div': {
      textAlign: 'left',
      wordBreak: 'break-word',
    },
  },
  selectedName: {
    color: '#051D39',
  },
  menuContainer: {
    position: 'absolute',
    right: '11px',
  },
});

export default styleSheet;
